module.exports = __webpack_public_path__ + "img/gestao.35c14c71.jpg";